<aberration-extra-details
        [currentAberration]="modalPayload.currentAberration"
        [testTypeId]="modalPayload.testTypeId"
        [currentOpinion]="modalPayload.currentOpinion"
        [testTableData]="modalPayload.testTableData"
        [currentModality]="modalPayload.currentModality"
        [revisionId]="modalPayload.revisionId"
        [firstRevisionId]="modalPayload.firstRevisionId"
        [filterSelected]="modalPayload.filterSelected"
        [igvOnly]="modalPayload.igvOnly"
        [currentSort]="modalPayload.currentSort"
        (noteChanged)="noteChanged($event)"
        (selectionChanged)="selectionChanged($event)">
</aberration-extra-details>